<template>
    <span class="notification-app-name">
        {{prefix}}{{ app_name }}{{suffix}}
    </span>

</template>
<script>



    export default {
        name: 'AppName',

        data() {

            return {

                app_name_maps : {

                    'chrome'    :   'Chrome',
                    'orologio'  :   'Clock',
                    'calendario'  :   'Calendar',
                    'tim telefono'  :   'Phone provider',
                    'chiama'  :   'Phone',
                    'messaggi'  :   'SMS',
                    'telefono'  :   'Phone',
                    'meteo'  :   'Weather',
                    'gestione download'  :   'Download',
                    'sistema android'   :   'Android',
                    'note di keep'  :   'Keep',
                    'google play services' : 'Google',
                    'impostaz. utente'  :   'Setting',
                    'doppio account'  :   'Setting',
                    'installazione pacchetti'  :   'Setting',
                    'servizi per gli sfondi'    :   'Setting',

                }

            }

        },

        props: {
            app: {
                default: null
            },
            prefix: {
                default: null
            },
            suffix: {
                default: null
            }

        },

        created() {


        },

        methods: {



        },

        computed: {

            app_name() {

                return (this.app_name_maps[this.app.toLowerCase()]) ? this.app_name_maps[this.app.toLowerCase()] : this.app;
            }

        },

        watch: {


        }


    }
</script>

<style lang="scss">

    .single-bell {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        position: relative;


    }

    .single-bell-info {
        opacity: 0;
        text-align: center;

        &.show {
            transition: all .375s ease-in;
            transition-delay: .5s;
            opacity: 1;
        }
    }

    .single-bell-emoji {
        font-size: 7vmax;
        width: 0;
        display: inline-block;
        overflow: hidden;
        transition: all .375s ease-in;
        //transition-delay: 1s;
        opacity: 0;
        display: inline-block;

        text-align: center;

        transform-origin: top center;
        transition: transform .25s ease;
        transition-timing-function: cubic-bezier(0.64, 0.57, 0.67, 1.53);

        &:hover {
            transform: rotate(3deg);
        }

        cursor: default;

        &.show {
            opacity: 1;
            width: 9vmax;


        }


    }


</style>
